import { createContext, ChangeEvent } from 'react';

type contextProps =
  | {
      name?: string;
      value?: string;
      required?: boolean;
      disabled?: boolean;
      readOnly?: boolean;
      color?: 'primary' | 'secondary';
      onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    }
  | undefined;

const CheckboxGroupContext = createContext<contextProps>(undefined);

export default CheckboxGroupContext;
